import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TargetAudienceSection() {
  return <section className="py-20 bg-[#0a0e27] relative" data-id="element-254">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-256">
          {/* Who it's for */}
          <div className="bg-green-900/10 border border-green-500/20 rounded-3xl p-8 md:p-10" data-id="element-257">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 flex items-center" data-id="element-258">
              <span className="bg-green-500/20 text-green-400 p-2 rounded-lg mr-4" data-id="element-259">
                <CheckCircle2 className="w-6 h-6" data-id="element-260" />
              </span>
              Esto SÍ es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-261">
              <li className="flex items-start" data-id="element-262">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-263" />
                <span className="text-gray-300 text-lg" data-id="element-264">
                  Sientes que tu "suerte" cambió de golpe y nada te sale bien,
                  sin explicación lógica.
                </span>
              </li>
              <li className="flex items-start" data-id="element-265">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-266" />
                <span className="text-gray-300 text-lg" data-id="element-267">
                  Eres emprendedor, líder o persona visible y sufres de envidias
                  constantes que frenan tu progreso.
                </span>
              </li>
              <li className="flex items-start" data-id="element-268">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-269" />
                <span className="text-gray-300 text-lg" data-id="element-270">
                  Padeces de cansancio crónico, pesadillas o insomnio que los
                  médicos no logran explicar.
                </span>
              </li>
              <li className="flex items-start" data-id="element-271">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-272" />
                <span className="text-gray-300 text-lg" data-id="element-273">
                  Sospechas firmemente ser víctima de trabajos de magia, mal de
                  ojo o entidades parasitarias.
                </span>
              </li>
            </ul>
          </div>

          {/* Who it's not for */}
          <div className="bg-red-900/10 border border-red-500/20 rounded-3xl p-8 md:p-10" data-id="element-274">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 flex items-center" data-id="element-275">
              <span className="bg-red-500/20 text-red-400 p-2 rounded-lg mr-4" data-id="element-276">
                <XCircle className="w-6 h-6" data-id="element-277" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-278">
              <li className="flex items-start" data-id="element-279">
                <XCircle className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-280" />
                <span className="text-gray-300 text-lg" data-id="element-281">
                  Buscas este conocimiento para dañar, manipular o vengarte de
                  otras personas (magia negra).
                </span>
              </li>
              <li className="flex items-start" data-id="element-282">
                <XCircle className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-283" />
                <span className="text-gray-300 text-lg" data-id="element-284">
                  Esperas resultados "mágicos" instantáneos sin estar dispuesto
                  a seguir las instrucciones y protocolos de la guía.
                </span>
              </li>
              <li className="flex items-start" data-id="element-285">
                <XCircle className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-286" />
                <span className="text-gray-300 text-lg" data-id="element-287">
                  No crees en la energía y piensas que todo es pura coincidencia
                  o sugestión psicológica.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}